const ProcessTimeline = () => {
  const steps = [
    {
      number: '01',
      title: 'Discovery',
      description: 'We analyze your business, audience, and competitors to create a tailored strategy.',
      color: '#FF6B35',
    },
    {
      number: '02',
      title: 'Strategy',
      description: 'Develop comprehensive marketing plans aligned with your business objectives.',
      color: '#00D9FF',
    },
    {
      number: '03',
      title: 'Execution',
      description: 'Implement campaigns with precision and creativity across all channels.',
      color: '#10B981',
    },
    {
      number: '04',
      title: 'Optimization',
      description: 'Continuously monitor, test, and refine strategies for maximum performance.',
      color: '#6B46C1',
    },
    {
      number: '05',
      title: 'Growth',
      description: 'Scale successful campaigns and explore new opportunities for expansion.',
      color: '#F59E0B',
    },
  ];

  return (
    <section className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-5xl font-bold text-dark text-center mb-20">
          Our Proven Process
        </h2>

        <div className="relative">
          {/* Connection Line */}
          <div className="absolute top-16 left-0 right-0 h-1 bg-gradient-to-r from-accent via-secondary to-primary hidden lg:block"></div>

          {/* Steps */}
          <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative flex flex-col items-center text-center">
                {/* Node */}
                <div
                  className="w-24 h-24 rounded-full flex items-center justify-center text-3xl font-bold text-white mb-6 relative z-10 shadow-2xl"
                  style={{
                    backgroundColor: step.color,
                    boxShadow: `0 20px 40px ${step.color}40`,
                  }}
                >
                  {step.number}
                </div>

                {/* Content */}
                <h3 className="text-2xl font-bold text-dark mb-3">
                  {step.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessTimeline;
